import { store } from "redux/store";

const getCurrentAudioLanguage = () => {
  let currentAudioLanguage = store?.getState()?.app?.audioLanguage;

  return currentAudioLanguage;
};

export default getCurrentAudioLanguage;
